
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_11166_534097)","stroke":"#545C69","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M8.537 7.886a1.349 1.349 0 01-1.074 0L.949 4.869a.64.64 0 010-1.143L7.463.686a1.349 1.349 0 011.074 0l6.514 3.017a.64.64 0 010 1.143l-6.514 3.04zM15.429 8.4l-6.972 3.212a1.143 1.143 0 01-.948 0L.57 8.4M15.429 12.115l-6.972 3.212a1.143 1.143 0 01-.948 0L.57 12.115"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_11166_534097"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    